import { Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { LocalService, NcWeatherOptions } from './local.service';

export type NcPositionType = 'rightBottom' | 'leftBottom' | 'rightTop' | 'leftTop';
export type NcAnimationType = 'default' | 'fade' | 'slide';

const fadeInOut = trigger('fadeInOut', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate(400, style({ opacity: 1 }))
  ]),
  transition(':leave', [
    animate(400, style({ opacity: 0 }))
  ])
]);

const slideInOut = trigger('slideInOut', [
  transition(':enter', [
    style({ transform: 'translateY(-100%)' }),
    animate(300, style({ transform: 'translateY(0)' }))
  ]),
  transition(':leave', [
    animate(300, style({ transform: 'translateY(-100%)' }))
  ])
]);

@Component({
  selector: 'nc-weather',
  templateUrl: './weather.component.html',
  styleUrls: ['./weather.component.less'],
  animations: [fadeInOut, slideInOut]
})
export class WeatherComponent implements OnInit, OnDestroy, OnChanges {
  /** token */
  @Input() ncToken: string = '';
  /** 经度 */
  @Input() ncLng: string | number = '';
  /** 纬度 */
  @Input() ncLat: string | number = '';
  /** 刷新频率：分钟 */
  @Input() ncInterval: number = 30;
  /** 详情面板相对于bar的位置 */
  @Input() ncPosition: NcPositionType = 'rightBottom';
  /** 动画类型：fade：淡入淡出 slide：滑入滑出 default：无动画 */
  @Input() ncAnimation: NcAnimationType = 'default';
  /** 是否显示位置信息 */
  private _showLocation: boolean = false;
  @Input() set ncShowLocation(value: boolean | string) {
    this._showLocation = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncShowLocation(): boolean {
    return this._showLocation;
  }
  /** 24小时预报 */
  private _showHourly: boolean = false;
  @Input() set ncShowHourly(value: boolean | string) {
    this._showHourly = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncShowHourly(): boolean {
    return this._showHourly;
  }
  /** 5天预报 */
  private _showDaily: boolean = false;
  @Input() set ncShowDaily(value: boolean | string) {
    this._showDaily = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncShowDaily(): boolean {
    return this._showDaily;
  }
  /** 生活指数 */
  private _showLife: boolean = false;
  @Input() set ncShowLife(value: boolean | string) {
    this._showLife = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncShowLife(): boolean {
    return this._showLife;
  }

  detailShow: boolean = false;
  weatherData: any = {};
  reloadInterval: any;
  private initialized: boolean = false;

  constructor(private ls: LocalService) {
  }

  async ngOnInit(): Promise<void> {
    if (this.ncToken == '') {
      console.error('ncToken为空');
      return;
    }
    await this.getWeatherData();
    this.initialized = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // 组件初始化后且经纬度发生变化时重新获取数据
    if (this.initialized && this.ncToken && (changes['ncLng'] || changes['ncLat'])) {
      this.getWeatherData();
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.reloadInterval);
  }

  async getWeatherData() {
    if (this.reloadInterval) {
      clearInterval(this.reloadInterval);
      this.reloadInterval = null;
    }
    await this.updateWeatherData();
    this.reloadInterval = setInterval(async () => {
      await this.updateWeatherData();
    }, this.ncInterval * 60 * 1000);
  }

  async updateWeatherData() {
    const options: NcWeatherOptions = {
      lng: this.ncLng,
      lat: this.ncLat
    }
    let data = await this.ls.getWeather(this.ncToken, options);
    //对温度取整、时间处理
    data.realtime.temperature.value = Math.round(data.realtime.temperature.value);
    data.realtime.temperature.min = Math.round(data.realtime.temperature.min);
    data.realtime.temperature.max = Math.round(data.realtime.temperature.max);
    data.serverTime.value = this.ls.formatDate('HH:mm', data.serverTime.value);
    for (let h of data.hourly.value) {
      h.time = this.ls.formatDate('HH时', h.time);
      h.temperature.value = Math.round(h.temperature.value);
    }
    for (let d of data.daily.value) {
      d.date = this.ls.formatDate('MM-dd', d.date);
      d.temperature.min = Math.round(d.temperature.min);
      d.temperature.max = Math.round(d.temperature.max);
    }
    this.weatherData = data;
  }
}
